import { Pipe, PipeTransform } from '@angular/core';
import { ICombineEngine } from '../interfaces';
import { find } from 'lodash';
import { Line } from '@app/core';

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {

    transform(lines: Line[], args?: any): Line[] {
        // console.log('filtre->',new Date(), lines);
        return lines;
    }

}
